import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class SplashScreenContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.interactive = true;
        this.buttonMode = true;

        this.init();
        this.addListeners();
        this.hide();
    }

    init() {
        this.pressAnywhere = this.getChildByName('pressAnywhere');
        this.hitArea = new PIXI.Rectangle(0,0, this.width, this.height);
    }

    addListeners() {
        GlobalDispatcher.add('stateStart:splashScreenState', this.show, this);
        GlobalDispatcher.add('stateEnd:splashScreenState', this.hide, this);
        GlobalDispatcher.add('scaleManager:resize', this.onGameResized, this);
        this.on('pointertap', this.onClick, this);
    }

    onGameResized(event) {
        if (EntryPoint.mobile) {
            if(event.params.canvasWidth > event.params.canvasHeight) {
                this.goToFrame(2);
            } else {
                this.goToFrame(1);
            }
            this.init();
            this.pressAnywhere.y = event.params.canvasHeight - 200;
        }
        this.hitArea = new PIXI.Rectangle(0,0, event.params.canvasWidth, event.params.canvasHeight);
    }

    onClick(event) {
        GlobalDispatcher.dispatch('splashScreenClose');
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }
}